import React from 'react'

function CalenderIntegration() {
    return (
        <div>
            CalenderIntegration page
        </div>
    )
}

export default CalenderIntegration
